import styled from 'styled-components';
import { Row } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const VerticalLine = styled.div`
  border-right: solid 1px rgb(188, 188, 188);
  padding: 0 16px;
`;

export const StyledExtrasContainer = styled(Row)`
  background: white;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  padding: 24px 16px;
`;

export const StyledPrice = styled.div`
  background: ${colours.Greyscale.SilverGrey};
  padding: 20px 16px;
  text-align: left;
`;

export const StyledHr = styled.hr`
  width: 100%;
  color: rgb(188, 188, 188);
`;
